document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (e) {
  document.querySelectorAll('details[data-dropdown]').forEach(function (menu) {
    if (!menu.contains(e.target)) menu.removeAttribute('open');
  });
});

document.querySelectorAll('details[data-dropdown]').forEach(function (menu) {
  menu.addEventListener('toggle', function () {
    if (menu.open) {
      document.querySelectorAll('details[data-dropdown][open]').forEach(function (other) {
        if (other !== menu && !other.contains(menu) && !menu.contains(other)) {
          other.removeAttribute('open');
        }
      });
    }
  });
  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { menu.removeAttribute('open'); });
  });
});

(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  function update() {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// Filtros de colección: aplican solos al tildar un checkbox
(function () {
  var filterForm = document.getElementById('CollectionFilters');
  if (!filterForm) return;
  filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () { filterForm.submit(); });
  });
})();

// Cerrar el menú móvil a pantalla completa con el botón X
document.querySelectorAll('[data-mobile-close]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var menu = btn.closest('details[data-mobile-menu]');
    if (menu) menu.removeAttribute('open');
  });
});

// Panel de filtros en mobile: abre/cierra como hoja lateral
(function () {
  var sidebar = document.querySelector('[data-filter-sidebar]');
  var overlay = document.querySelector('.collection-page__sidebar-overlay');
  var openBtns = document.querySelectorAll('[data-open-filters]');
  var closeBtns = document.querySelectorAll('[data-close-filters]');
  if (!sidebar) return;

  function openFilters() {
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(function (btn) { btn.addEventListener('click', openFilters); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeFilters); });
})();

// Buscador de productos dentro de la colección (filtra lo ya cargado en pantalla)
(function () {
  var input = document.querySelector('[data-collection-search]');
  var grid = document.querySelector('[data-product-grid]');
  var noResults = document.querySelector('[data-no-search-results]');
  if (!input || !grid) return;

  input.addEventListener('input', function () {
    var term = input.value.trim().toLowerCase();
    var cards = grid.querySelectorAll('.product-card');
    var visibleCount = 0;
    cards.forEach(function (card) {
      var title = card.querySelector('.product-card__title');
      var text = title ? title.textContent.toLowerCase() : '';
      var matches = term === '' || text.indexOf(term) !== -1;
      card.style.display = matches ? '' : 'none';
      if (matches) visibleCount++;
    });
    if (noResults) noResults.hidden = visibleCount !== 0 || term === '';
  });
})();

// Buscador con overlay centrado y sugerencias en vivo
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var clearBtn = overlay.querySelector('[data-search-clear]');
  var submitBtn = overlay.querySelector('[data-search-submit]');
  var closeBtn = overlay.querySelector('[data-search-close]');
  var resultsBox = overlay.querySelector('[data-search-results]');
  var suggestionsList = overlay.querySelector('[data-search-suggestions]');
  var suggestionsCol = overlay.querySelector('[data-search-suggestions-col]');
  var productsList = overlay.querySelector('[data-search-products]');
  var searchUrl = overlay.dataset.searchUrl || '/search';
  var debounceTimer;
  var currentFetchTerm = '';

  function clearResults() {
    if (suggestionsList) suggestionsList.innerHTML = '';
    if (productsList) productsList.innerHTML = '';
    if (resultsBox) resultsBox.classList.remove('is-visible');
    if (suggestionsCol) suggestionsCol.hidden = false;
  }

  function openOverlay() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }
  function closeOverlay() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openOverlay();
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      clearBtn.hidden = true;
      currentFetchTerm = '';
      clearResults();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  function renderResults(data, term) {
    // Evita pintar resultados de una búsqueda vieja que llegó tarde (fuera de orden)
    if (term !== currentFetchTerm) return;

    var collections = (data && data.resources && data.resources.results.collections) || [];
    var products = (data && data.resources && data.resources.results.products) || [];

    if (suggestionsList) {
      suggestionsList.innerHTML = '';
      collections.slice(0, 8).forEach(function (col) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = col.url;
        a.textContent = col.title;
        li.appendChild(a);
        suggestionsList.appendChild(li);
      });
    }
    if (suggestionsCol) suggestionsCol.hidden = collections.length === 0;

    if (productsList) {
      productsList.innerHTML = '';
      products.slice(0, 10).forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'search-overlay__product';

        var img = document.createElement('img');
        img.src = p.image || '';
        img.alt = p.title || '';

        var titleEl = document.createElement('span');
        titleEl.className = 'search-overlay__product-title';
        titleEl.textContent = p.title;

        a.appendChild(img);
        a.appendChild(titleEl);
        li.appendChild(a);
        productsList.appendChild(li);
      });
    }

    if (resultsBox) {
      var hasResults = collections.length > 0 || products.length > 0;
      resultsBox.classList.toggle('is-visible', hasResults);
    }
  }

  if (input) {
    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (clearBtn) clearBtn.hidden = term === '';
      clearTimeout(debounceTimer);

      if (term.length < 2) {
        currentFetchTerm = '';
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        currentFetchTerm = term;
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderResults(data, term); })
          .catch(function () { renderResults(null, term); });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var term = input.value.trim();
        if (term) window.location.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
      }
    });
  }
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var term = input ? input.value.trim() : '';
      if (term) window.location.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
    });
  }
})();

// Carrito lateral (drawer): abre con el ícono del header, se actualiza con AJAX
window.CVLCart = (function () {
  var drawer, itemsEl, emptyEl, subtotalEl, countEl, membershipMsgEl, membershipBarEl;
  var membershipGoal = 0;
  var membershipTemplate = '';
  var membershipComplete = '';

  function moneyFmt(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toString();
    }
  }

  function init() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    countEl = drawer.querySelector('[data-cart-drawer-count]');
    membershipMsgEl = drawer.querySelector('[data-cart-membership-message]');
    membershipBarEl = drawer.querySelector('[data-cart-membership-bar]');
    membershipGoal = parseInt(drawer.dataset.membershipGoal, 10) || 25000000;
    membershipTemplate = drawer.dataset.membershipTemplate || '';
    membershipComplete = drawer.dataset.membershipComplete || '';

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.querySelectorAll('[data-cart-icon]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    fetchCart();
  }

  function render(cart) {
    if (!drawer) return;

    if (countEl) countEl.textContent = '\u2022 ' + cart.item_count;
    if (subtotalEl) subtotalEl.textContent = '$' + moneyFmt(cart.total_price) + ' CLP';

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    if (emptyEl) emptyEl.style.display = cart.item_count === 0 ? '' : 'none';

    if (itemsEl) {
      itemsEl.style.display = cart.item_count === 0 ? 'none' : '';
      itemsEl.innerHTML = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-drawer__item';

        var img = document.createElement('img');
        img.className = 'cart-drawer__item-img';
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        img.alt = item.product_title || '';

        var info = document.createElement('div');
        info.className = 'cart-drawer__item-info';

        var titleEl = document.createElement('p');
        titleEl.className = 'cart-drawer__item-title';
        titleEl.textContent = item.product_title;
        info.appendChild(titleEl);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          var varEl = document.createElement('p');
          varEl.className = 'cart-drawer__item-variant';
          varEl.textContent = item.variant_title;
          info.appendChild(varEl);
        }

        var qtyWrap = document.createElement('div');
        qtyWrap.className = 'cart-drawer__item-qty';
        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'cart-drawer__qty-btn';
        minusBtn.textContent = '\u2212';
        minusBtn.addEventListener('click', function () {
          changeQty(item.key, Math.max(0, item.quantity - 1));
        });
        var qtySpan = document.createElement('span');
        qtySpan.textContent = item.quantity;
        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'cart-drawer__qty-btn';
        plusBtn.textContent = '+';
        plusBtn.addEventListener('click', function () {
          changeQty(item.key, item.quantity + 1);
        });
        qtyWrap.appendChild(minusBtn);
        qtyWrap.appendChild(qtySpan);
        qtyWrap.appendChild(plusBtn);
        info.appendChild(qtyWrap);

        var right = document.createElement('div');
        right.className = 'cart-drawer__item-right';
        var priceEl = document.createElement('span');
        priceEl.className = 'cart-drawer__item-price';
        priceEl.textContent = '$' + moneyFmt(item.final_line_price);
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-drawer__item-remove';
        removeBtn.innerHTML = '&times;';
        removeBtn.addEventListener('click', function () {
          changeQty(item.key, 0);
        });
        right.appendChild(priceEl);
        right.appendChild(removeBtn);

        li.appendChild(img);
        li.appendChild(info);
        li.appendChild(right);
        itemsEl.appendChild(li);
      });
    }

    if (membershipMsgEl && membershipGoal > 0) {
      var remaining = membershipGoal - cart.total_price;
      if (remaining > 0) {
        membershipMsgEl.textContent = membershipTemplate.replace('{{remaining}}', '$' + moneyFmt(remaining) + ' CLP');
      } else {
        membershipMsgEl.textContent = membershipComplete;
      }
    }
    if (membershipBarEl && membershipGoal > 0) {
      var pct = Math.min(100, Math.max(0, (cart.total_price / membershipGoal) * 100));
      membershipBarEl.style.width = pct + '%';
    }
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        return cart;
      });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function addItem(formData) {
    return fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        open();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { open: open, close: close, addItem: addItem, fetchCart: fetchCart };
})();
